import ExcelJS from 'exceljs'

export const logoBase64 = ''

class ExcelPlugin {
  async downloadFile (pages, data, title = 'BID', filename = 'BID.xlsx', logoBase64, conditionalRendering) {
    let workbook = this.createBook()
    pages.forEach((page) => {
      workbook = this.setWorkBook(page.product, workbook, page.columns, data, logoBase64, title, page.product, conditionalRendering)
    })
    await this.downloadWorkBook(workbook, filename)
  }

  setWorkBook (titleWorkSheet, workbook, header, data, logoBase64, title, subtitle, conditionalRendering) {
    const worksheet = workbook.addWorksheet(titleWorkSheet)
    // Add new row

    const titleRow = worksheet.addRow([title])
    worksheet.addRow([])
    const subtitleRow = worksheet.addRow([subtitle])

    // Set font, size and style in title row.
    titleRow.font = { name: 'Arial', bold: true }
    subtitleRow.font = { name: 'Arial', bold: true }

    // Blank Row
    const EColumn = String.fromCharCode(64 + (header.length + 1) * 2)
    worksheet.mergeCells(`A1:${EColumn}2`) // Extend cell over all column headers
    worksheet.mergeCells(`A3:${EColumn}3`) // Extend cell over all column headers
    titleRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        // documentacion : http://namaste-android.blogspot.com/2012/03/argb-color-codes.html
        fgColor: { argb: 'FFC0C0C0' },
        bgColor: { argb: 'FFC0C0C0' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    subtitleRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        // documentacion : http://namaste-android.blogspot.com/2012/03/argb-color-codes.html
        fgColor: { argb: 'FFC0C0C0' },
        bgColor: { argb: 'FFC0C0C0' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    worksheet.getCell('A1').alignment = { vertical: 'middle', horizontal: 'center' }
    worksheet.getCell('A3').alignment = { vertical: 'middle', horizontal: 'center' }

    if (logoBase64) {
      const logo = workbook.addImage({
        base64: logoBase64,
        extension: 'png'
      })
      worksheet.addImage(logo, 'E1:F3')
    }

    // Add Header Row
    const newHeader = [' ']
    header.map(x => x.name + ' \n ' + x.subtitle).forEach(name => {
      newHeader.push(name)
      newHeader.push('')
    })
    newHeader.push(' ')

    const headerRow = worksheet.addRow(newHeader)
    headerRow.font = { name: 'Arial', bold: true }
    headerRow.height = 68
    headerRow.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC0C0C0' },
        bgColor: { argb: 'FFC0C0C0' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })

    // Add Data and Conditional Formatting
    data.forEach(d => {
      const row = worksheet.addRow(d)
      row.eachCell((cell, number) => {
        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
      })
      if (conditionalRendering) {
        conditionalRendering(row)
      }
    })

    for (let i = 1; i <= newHeader.length; i++) {
      const currentColumn = worksheet.getColumn(i)
      currentColumn.width = 18
      if (currentColumn.values[4] === '') {
        currentColumn.width = 20
        const startMerge = worksheet.getColumn(i - 1).letter
        const endMerge = currentColumn.letter
        worksheet.mergeCells(`${startMerge}4:${endMerge}4`) // Extend cell over all column headers
        worksheet.getCell(`${startMerge}4`).alignment = { vertical: 'middle', horizontal: 'center', wrapText: true }
      }
    }

    let rows = []
    for (let i = 0; i < header.length; i++) {
      rows = [...rows, 'Fecha', 'Temperatura']
    }
    rows = ['Lote', ...rows, 'Observaciones']
    const rowsDateTemperature = worksheet.addRow(rows)
    rowsDateTemperature.eachCell((cell, number) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFC0C0C0' },
        bgColor: { argb: 'FFC0C0C0' }
      }
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
    })
    rowsDateTemperature.font = { name: 'Arial', bold: true }

    return workbook
  }

  createBook (creator = 'BID', lastModifiedBy = 'BID') {
    const workbook = new ExcelJS.Workbook()
    workbook.creator = creator
    workbook.lastModifiedBy = lastModifiedBy
    workbook.created = new Date()
    return workbook
  }

  async downloadWorkBook (workbook, filename) {
    const data = await workbook.xlsx.writeBuffer()
    const blob = new Blob([data], { type: this.blobType })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.href = url
    a.download = filename
    a.click()
  }
}
export default ExcelPlugin
